'use strict';

import _firebase from './_firebase.js';

import axios from 'axios';

const address = "https://rosepetal-orchestrator-685118579523.us-central1.run.app"

const  sam = {
    /**
	 * Sends an image to the SAM service.
	 *
	 * @param {string} image_uri - The image to cache.
	 * @param {string} projectId - The project ID for Firebase.
	 * @returns {Promise<any>} - The response data from the VLM service.
	 */
    setImage: async function (image_uri, projectId) {
        const token = _firebase.auth.currentUser.accessToken;
		const accesToken = 'Bearer ' + token;
		try {
			const response = await axios.post( 
				`${address}/inference/sam/`,
				{ 
                    image: image_uri,
                    type: "single", // TODO: add type to the request (single/batch)
                    firebase_bucket_name: projectId,
					"mode": "detection" // TODO: take this out when solved in BackEnd
                },
				{
					responseType: 'json',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': accesToken,
						"Firebase-Project-ID": projectId
					}
				}
			);
			return response.data;
		} catch (error) {
			console.error("Error fetching result:", error);
			throw error;
		}
    },
    /**
	 * Sends an image to the SAM service.
	 *
	 * @param {string} image_uri - The image to cache.
	 * @param {string} projectId - The project ID for Firebase.
     * @param {string} mode - detection/segmentation
     * @param {Array} predictedPoints - The points to predict.
     * @param {Array} predictedBoundingBoxes - The bounding boxes to predict.]}
	 * @returns {Promise<any>} - The response data from the SAM service.
	 */
    predict: async function (image_uri, projectId, mode, predictedPoints, predictedBoundingBoxes) {
        const token = _firebase.auth.currentUser.accessToken;
		const accesToken = 'Bearer ' + token;

        try {
			const formattedPoints = predictedPoints.map(([coords, label]) => [...coords, label]);

			const response = await axios.post(
				`${address}/inference/sam/`,
				{ 
                    type: "single", // TODO: add type to the request (single/batch)
                    image: image_uri,
                    firebase_bucket_name: projectId,
                    mode,
                    box_prompts: (Array.isArray(predictedBoundingBoxes) && predictedBoundingBoxes.length > 0) ? [predictedBoundingBoxes] : null,
                    point_prompts: formattedPoints
                },
				{
					responseType: 'json',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': accesToken,
						"Firebase-Project-ID": projectId
					}
				}
			);
			return response.data;
		} catch (error) {
			console.error("Error fetching predictions:", error);
			throw error;
		}
    },
	/**
	 * 
	 * @param {string} projectId 
	 * @returns {Promise<any>} - The response data from the VLM service.
	 */
	checkSAMhealth: async function (projectId) {
		const token = _firebase.auth.currentUser.accessToken;
		const accesToken = 'Bearer ' + token;
		try {
			console.log("Checking SAM health...");
			const response = await axios.get(
				`${address}/service/sam/`,
				{
					responseType: 'json',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': accesToken,
						"Firebase-Project-ID": projectId
					}
				}
			);
			console.log("SAM health check response:", response);
			return response.data;
		} catch (error) {
			console.error("Error fetching result:", error);
			throw error;
		}
	}
}

export default sam;